export interface SubtitleVersion {
  id: string;
  label: string;
  format: string;
  language: string;
  size: string;
  lines: string[];
}

export interface Subtitle {
  id: string;
  title: string;
  originalTitle: string;
  type: string;
  typeSlug: string;
  year: number;
  cover: string;
  format: string;
  language: string;
  size: string;
  updatedAt: string;
  runtime: string;
  region: string;
  rating: number;
  downloads: number;
  featured: boolean;
  summary: string;
  tags: string[];
  versions: SubtitleVersion[];
}

export const subtitles: Subtitle[] = [
  {
    id: "interstellar-2014",
    title: "星际穿越",
    originalTitle: "Interstellar",
    type: "电影",
    typeSlug: "movie",
    year: 2014,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%2C%20lone%20astronaut%20silhouette%20facing%20a%20giant%20ringed%20planet%2C%20deep%20blue%20and%20charcoal%20tones%2C%20minimal%20premium%20poster%20art%2C%20soft%20cinematic%20glow%2C%20no%20text&width=400&height=600&seq=sub-cover-01&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "78 KB",
    updatedAt: "2026-10-08",
    runtime: "169 分钟",
    region: "美国 / 英国",
    rating: 9.4,
    downloads: 128400,
    featured: true,
    summary:
      "经典硬科幻巨制《星际穿越》完整时间轴中文字幕，对白、旁白与屏幕文字注释齐全，时间轴精准匹配 169 分钟 BluRay 版本，适合搭配 4K 高清片源使用。",
    tags: ["科幻", "冒险", "时间轴精准", "蓝光版"],
    versions: [
      {
        id: "interstellar-2014-srt-sc",
        label: "简体中文 SRT",
        format: "srt",
        language: "简体中文",
        size: "78 KB",
        lines: [
          "00:12:04,320 --> 00:12:07,880  我们曾经仰望星空，思考我们在宇宙中的位置。",
          "00:12:08,100 --> 00:12:11,540  而现在，我们只能低头，担忧如何在这片土地上生存。",
          "00:24:37,600 --> 00:24:41,220  人类生于地球，却注定不会毁灭于此。",
          "00:58:12,900 --> 00:58:16,480  不要温和地走进那个良夜。",
          "01:44:20,150 --> 01:44:24,300  爱是唯一可以超越时间与空间的事物。",
        ],
      },
      {
        id: "interstellar-2014-ass-biling",
        label: "中英双语 ASS",
        format: "ass",
        language: "中英双语",
        size: "1.2 MB",
        lines: [
          "00:12:04,320 --> 00:12:07,880  We used to look up at the sky and wonder at our place in the stars.",
          "00:12:04,320 --> 00:12:07,880  我们曾经仰望星空，思考我们在宇宙中的位置。",
          "00:58:12,900 --> 00:58:16,480  Do not go gentle into that good night.",
          "00:58:12,900 --> 00:58:16,480  不要温和地走进那个良夜。",
        ],
      },
    ],
  },
  {
    id: "inception-2010",
    title: "盗梦空间",
    originalTitle: "Inception",
    type: "电影",
    typeSlug: "movie",
    year: 2010,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20heist%20movie%20poster%2C%20impossible%20folding%20city%20skyline%20bending%20into%20itself%2C%20teal%20and%20amber%20highlights%20on%20dark%20background%2C%20minimal%20premium%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-02&orientation=portrait",
    format: "ass",
    language: "中英双语",
    size: "986 KB",
    updatedAt: "2026-10-07",
    runtime: "148 分钟",
    region: "美国 / 英国",
    rating: 9.3,
    downloads: 96200,
    featured: true,
    summary:
      "《盗梦空间》中英双语特效字幕，含梦境层次注释与字体特效样式，时间轴匹配 148 分钟版本，支持 ASS 特效样式直接外挂播放器。",
    tags: ["悬疑", "科幻", "特效字幕", "双语"],
    versions: [
      {
        id: "inception-2010-ass-biling",
        label: "中英双语 ASS（特效）",
        format: "ass",
        language: "中英双语",
        size: "986 KB",
        lines: [
          "00:09:41,200 --> 00:09:45,600  What is the most resilient parasite? An idea.",
          "00:09:41,200 --> 00:09:45,600  什么是最顽强的寄生虫？一个想法。",
          "00:31:15,780 --> 00:31:19,340  You mustn't be afraid to dream a little bigger, darling.",
          "00:31:15,780 --> 00:31:19,340  别害怕把梦想做得更大一点，亲爱的。",
        ],
      },
      {
        id: "inception-2010-srt-sc",
        label: "简体中文 SRT",
        format: "srt",
        language: "简体中文",
        size: "72 KB",
        lines: [
          "00:09:41,200 --> 00:09:45,600  什么是最顽强的寄生虫？一个想法。",
          "00:52:08,400 --> 00:52:12,900  你在等待一列火车，它会带你去很远的地方。",
        ],
      },
    ],
  },
  {
    id: "farewell-my-concubine-1993",
    title: "霸王别姬",
    originalTitle: "Farewell My Concubine",
    type: "电影",
    typeSlug: "movie",
    year: 1993,
    cover:
      "https://readdy.ai/api/search-image?query=Classic%20period%20drama%20film%20poster%2C%20traditional%20Chinese%20opera%20stage%20with%20red%20lanterns%20and%20gold%20accents%20on%20dark%20crimson%20background%2C%20elegant%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-03&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "65 KB",
    updatedAt: "2026-10-06",
    runtime: "171 分钟",
    region: "中国大陆 / 中国香港",
    rating: 9.6,
    downloads: 145800,
    featured: true,
    summary:
      "华语影史巅峰之作《霸王别姬》精校中文字幕，收录唱词与方言注释，时间轴匹配 171 分钟修复版，适合经典影片收藏与字幕研究。",
    tags: ["剧情", "经典", "唱词注释", "修复版"],
    versions: [
      {
        id: "farewell-my-concubine-1993-srt-sc",
        label: "简体中文 SRT（含唱词注释）",
        format: "srt",
        language: "简体中文",
        size: "65 KB",
        lines: [
          "00:05:12,300 --> 00:05:16,800  说的是一辈子！差一年，一个月，一天，一个时辰，都不算一辈子！",
          "00:18:40,500 --> 00:18:44,900  【唱词】自从我随大王东征西战，受风霜与劳碌年复年年。",
          "01:02:33,200 --> 01:02:37,600  虞姬为什么要死？因为她从一而终。",
        ],
      },
    ],
  },
  {
    id: "let-the-bullets-fly-2010",
    title: "让子弹飞",
    originalTitle: "Let the Bullets Fly",
    type: "电影",
    typeSlug: "movie",
    year: 2010,
    cover:
      "https://readdy.ai/api/search-image?query=Western%20action%20movie%20poster%2C%20silhouette%20of%20a%20man%20in%20a%20trench%20coat%20and%20hat%20against%20a%20warm%20dusty%20sunset%2C%20amber%20and%20rust%20tones%20on%20dark%20background%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-04&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "58 KB",
    updatedAt: "2026-10-06",
    runtime: "132 分钟",
    region: "中国大陆",
    rating: 9.2,
    downloads: 88700,
    featured: false,
    summary:
      "《让子弹飞》齐麟版中文字幕，收录全部经典台词与四川方言对白，时间轴精准，支持 132 分钟院线完整版片源。",
    tags: ["喜剧", "动作", "方言注释", "台词经典"],
    versions: [
      {
        id: "let-the-bullets-fly-2010-srt-sc",
        label: "简体中文 SRT（含方言注释）",
        format: "srt",
        language: "简体中文",
        size: "58 KB",
        lines: [
          "00:14:20,300 --> 00:14:24,700  让子弹飞一会儿！",
          "00:45:12,800 --> 00:45:16,200  站着，还把钱挣了。",
          "01:10:05,400 --> 01:10:09,900  我就是想让你明白，鹅城的鹅，到底是不是鹅。",
        ],
      },
    ],
  },
  {
    id: "dune-part-two-2024",
    title: "沙丘2",
    originalTitle: "Dune: Part Two",
    type: "电影",
    typeSlug: "movie",
    year: 2024,
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20desert%20movie%20poster%2C%20vast%20sand%20dunes%20under%20a%20pale%20sun%20with%20a%20tiny%20lone%20figure%2C%20amber%20gold%20and%20deep%20olive%20tones%2C%20minimal%20premium%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-05&orientation=portrait",
    format: "ass",
    language: "中英双语",
    size: "1.4 MB",
    updatedAt: "2026-10-05",
    runtime: "166 分钟",
    region: "美国",
    rating: 8.9,
    downloads: 73200,
    featured: true,
    summary:
      "《沙丘2》中英双语特效字幕，含厄拉科斯星球术语表与外语注释，支持 ASS 特效样式，时间轴匹配 166 分钟蓝光版本。",
    tags: ["科幻", "冒险", "术语注释", "特效字幕"],
    versions: [
      {
        id: "dune-part-two-2024-ass-biling",
        label: "中英双语 ASS（特效）",
        format: "ass",
        language: "中英双语",
        size: "1.4 MB",
        lines: [
          "00:11:32,100 --> 00:11:35,800  Fear is the mind-killer.",
          "00:11:32,100 --> 00:11:35,800  恐惧是思维杀手。",
          "01:02:44,600 --> 01:02:48,200  Long live the fighters!",
          "01:02:44,600 --> 01:02:48,200  愿战士永生！",
        ],
      },
    ],
  },
  {
    id: "oppenheimer-2023",
    title: "奥本海默",
    originalTitle: "Oppenheimer",
    type: "电影",
    typeSlug: "movie",
    year: 2023,
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20historical%20biopic%20movie%20poster%2C%20a%20man%20in%20a%20homburg%20hat%20silhouetted%20against%20a%20glowing%20orange%20explosion%20cloud%2C%20black%20and%20amber%20tones%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-06&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "102 KB",
    updatedAt: "2026-10-04",
    runtime: "180 分钟",
    region: "美国 / 英国",
    rating: 8.8,
    downloads: 61400,
    featured: false,
    summary:
      "《奥本海默》IMAX 版中文字幕，含大量人名与物理学术语对照注释，时间轴匹配 180 分钟完整版，适合历史与科学题材爱好者。",
    tags: ["传记", "历史", "术语注释", "IMAX版"],
    versions: [
      {
        id: "oppenheimer-2023-srt-sc",
        label: "简体中文 SRT（含术语注释）",
        format: "srt",
        language: "简体中文",
        size: "102 KB",
        lines: [
          "00:21:15,400 --> 00:21:19,900  现在我成了死神，世界的毁灭者。",
          "01:15:33,200 --> 01:15:37,600  我们不是在创造武器，我们是在打开一扇门。",
        ],
      },
    ],
  },
  {
    id: "ne-zha-2-2025",
    title: "哪吒之魔童闹海",
    originalTitle: "Ne Zha 2",
    type: "电影",
    typeSlug: "movie",
    year: 2025,
    cover:
      "https://readdy.ai/api/search-image?query=Animated%20Chinese%20mythology%20movie%20poster%2C%20a%20young%20boy%20hero%20with%20fiery%20red%20ribbons%20standing%20amidst%20swirling%20flames%20and%20waves%2C%20vivid%20red%20and%20teal%20tones%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-07&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "69 KB",
    updatedAt: "2026-10-03",
    runtime: "144 分钟",
    region: "中国大陆",
    rating: 9.1,
    downloads: 159300,
    featured: true,
    summary:
      "现象级国产动画《哪吒之魔童闹海》中文字幕，收录全部台词与彩蛋注释，时间轴匹配 144 分钟影院版，适合亲子与国漫爱好者。",
    tags: ["动画", "神话", "国漫", "彩蛋注释"],
    versions: [
      {
        id: "ne-zha-2-2025-srt-sc",
        label: "简体中文 SRT",
        format: "srt",
        language: "简体中文",
        size: "69 KB",
        lines: [
          "00:16:42,500 --> 00:16:46,900  我命由我不由天，是魔是仙，我自己说了算！",
          "01:08:20,100 --> 01:08:24,700  若前方无路，我便踏出一条路。",
        ],
      },
    ],
  },
  {
    id: "the-wandering-earth-2-2023",
    title: "流浪地球2",
    originalTitle: "The Wandering Earth II",
    type: "电影",
    typeSlug: "movie",
    year: 2023,
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20blockbuster%20poster%2C%20giant%20planetary%20engines%20lifting%20earth%20against%20a%20star-filled%20sky%2C%20cool%20blue%20and%20white%20tones%2C%20minimal%20premium%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-08&orientation=portrait",
    format: "ass",
    language: "中英双语",
    size: "1.1 MB",
    updatedAt: "2026-10-02",
    runtime: "173 分钟",
    region: "中国大陆",
    rating: 8.7,
    downloads: 70100,
    featured: false,
    summary:
      "《流浪地球2》中英双语特效字幕，含科学设定名词注释与专业术语对照，时间轴匹配 173 分钟完整版，支持 ASS 特效样式。",
    tags: ["科幻", "灾难", "特效字幕", "术语注释"],
    versions: [
      {
        id: "the-wandering-earth-2-2023-ass-biling",
        label: "中英双语 ASS（特效）",
        format: "ass",
        language: "中英双语",
        size: "1.1 MB",
        lines: [
          "00:14:05,600 --> 00:14:09,800  希望，是这个时代像钻石一样珍贵的东西。",
          "01:22:31,400 --> 01:22:35,900  人类把最精密的保密系统，都用在了自己身上。",
        ],
      },
    ],
  },
  {
    id: "three-body-2023",
    title: "三体",
    originalTitle: "Three-Body",
    type: "电视剧",
    typeSlug: "tv",
    year: 2023,
    cover:
      "https://readdy.ai/api/search-image?query=Mysterious%20sci-fi%20TV%20series%20poster%2C%20a%20giant%20celestial%20sphere%20above%20a%20dark%20cityscape%20with%20faint%20red%20signal%20lines%2C%20deep%20blue%20and%20crimson%20tones%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-09&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "312 KB",
    updatedAt: "2026-10-08",
    runtime: "全 30 集",
    region: "中国大陆",
    rating: 8.9,
    downloads: 112500,
    featured: true,
    summary:
      "国产科幻剧《三体》全 30 集中文字幕打包，分集独立文件并附带科学名词注释，时间轴按集校对，适配 4K 剧集片源。",
    tags: ["科幻", "悬疑", "全季打包", "分集校对"],
    versions: [
      {
        id: "three-body-2023-srt-sc",
        label: "简体中文 SRT（全 30 集）",
        format: "srt",
        language: "简体中文",
        size: "312 KB",
        lines: [
          "【第 1 集】00:03:12,400 --> 00:03:16,900  不要回答！不要回答！不要回答！",
          "【第 5 集】00:22:40,300 --> 00:22:44,800  整个宇宙都将为你闪烁。",
          "【第 12 集】00:15:08,700 --> 00:15:13,200  弱小和无知不是生存的障碍，傲慢才是。",
        ],
      },
    ],
  },
  {
    id: "the-long-season-2023",
    title: "漫长的季节",
    originalTitle: "The Long Season",
    type: "电视剧",
    typeSlug: "tv",
    year: 2023,
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20drama%20series%20poster%2C%20a%20rusty%20abandoned%20train%20track%20through%20autumn%20fields%20under%20warm%20hazy%20light%2C%20amber%20and%20olive%20tones%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-10&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "168 KB",
    updatedAt: "2026-10-07",
    runtime: "全 12 集",
    region: "中国大陆",
    rating: 9.5,
    downloads: 98600,
    featured: false,
    summary:
      "口碑神作《漫长的季节》全 12 集中文字幕，收录东北方言对白与时代背景注释，时间轴精校，适合悬疑剧集爱好者收藏。",
    tags: ["悬疑", "剧情", "方言注释", "全季打包"],
    versions: [
      {
        id: "the-long-season-2023-srt-sc",
        label: "简体中文 SRT（全 12 集）",
        format: "srt",
        language: "简体中文",
        size: "168 KB",
        lines: [
          "【第 1 集】00:01:20,500 --> 00:01:25,700  往前走，别回头。",
          "【第 6 集】00:28:13,900 --> 00:28:18,400  人生就像一场戏，因为有缘才相聚。",
        ],
      },
    ],
  },
  {
    id: "blossoms-shanghai-2023",
    title: "繁花",
    originalTitle: "Blossoms Shanghai",
    type: "电视剧",
    typeSlug: "tv",
    year: 2023,
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20style%20drama%20poster%2C%20neon-lit%20Shanghai%20street%20at%20night%20with%20raindrops%20and%20warm%20golden%20reflections%2C%20amber%20and%20dark%20teal%20tones%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-11&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "204 KB",
    updatedAt: "2026-10-06",
    runtime: "全 30 集",
    region: "中国大陆",
    rating: 8.6,
    downloads: 65200,
    featured: false,
    summary:
      "王家卫监制剧集《繁花》全 30 集中文字幕，收录上海话对白与普通话双语对照注释，时间轴精校，适配高清剧集片源。",
    tags: ["剧情", "年代", "沪语注释", "全季打包"],
    versions: [
      {
        id: "blossoms-shanghai-2023-srt-sc",
        label: "简体中文 SRT（全 30 集）",
        format: "srt",
        language: "简体中文",
        size: "204 KB",
        lines: [
          "【第 1 集】00:05:40,200 --> 00:05:45,600  人生如戏，全靠演技。",
          "【第 18 集】00:31:12,400 --> 00:31:17,900  搞钱嘛，要紧的是有没有命花。",
        ],
      },
    ],
  },
  {
    id: "the-knockout-2023",
    title: "狂飙",
    originalTitle: "The Knockout",
    type: "电视剧",
    typeSlug: "tv",
    year: 2023,
    cover:
      "https://readdy.ai/api/search-image?query=Crime%20thriller%20China%20TV%20poster%2C%20lonely%20figure%20standing%20under%20a%20street%20lamp%20on%20a%20rainy%20night%20road%2C%20cool%20blue%20and%20amber%20tones%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-12&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "246 KB",
    updatedAt: "2026-10-05",
    runtime: "全 39 集",
    region: "中国大陆",
    rating: 8.7,
    downloads: 71800,
    featured: false,
    summary:
      "扫黑除恶题材爆款剧《狂飙》全 39 集中文字幕，收录全部台词与方言注释，时间轴按集校对，适合追剧与字幕学习。",
    tags: ["犯罪", "剧情", "全季打包", "分集校对"],
    versions: [
      {
        id: "the-knockout-2023-srt-sc",
        label: "简体中文 SRT（全 39 集）",
        format: "srt",
        language: "简体中文",
        size: "246 KB",
        lines: [
          "【第 1 集】00:02:35,600 --> 00:02:40,100  风浪越大，鱼越贵。",
          "【第 25 集】00:19:48,300 --> 00:19:53,800  别让人家瞧不起咱们。",
        ],
      },
    ],
  },
  {
    id: "game-of-thrones-2011",
    title: "权力的游戏",
    originalTitle: "Game of Thrones",
    type: "电视剧",
    typeSlug: "tv",
    year: 2011,
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20medieval%20series%20poster%2C%20an%20iron%20throne%20of%20swords%20in%20a%20dark%20stone%20hall%2C%20cold%20blue%20and%20steel%20grey%20tones%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-13&orientation=portrait",
    format: "ass",
    language: "中英双语",
    size: "3.6 MB",
    updatedAt: "2026-10-04",
    runtime: "全 8 季",
    region: "美国",
    rating: 9.3,
    downloads: 84300,
    featured: false,
    summary:
      "史诗奇幻剧《权力的游戏》全 8 季中英双语字幕，收录维斯特洛家族谱系与专有名词注释，时间轴完整校对，ASS 特效样式可用。",
    tags: ["奇幻", "史诗", "双语", "全季打包"],
    versions: [
      {
        id: "game-of-thrones-2011-ass-biling",
        label: "中英双语 ASS（全 8 季）",
        format: "ass",
        language: "中英双语",
        size: "3.6 MB",
        lines: [
          "S01E01 00:12:04,300 --> 00:12:08,800  Winter is coming.",
          "S01E01 00:12:04,300 --> 00:12:08,800  凛冬将至。",
          "S08E06 00:44:20,100 --> 00:44:24,600  There's nothing in the world more powerful than a good story.",
          "S08E06 00:44:20,100 --> 00:44:24,600  这世上没有什么比一个好故事更有力量。",
        ],
      },
    ],
  },
  {
    id: "stranger-things-2016",
    title: "怪奇物语",
    originalTitle: "Stranger Things",
    type: "电视剧",
    typeSlug: "tv",
    year: 2016,
    cover:
      "https://readdy.ai/api/search-image?query=Retro%2080s%20sci-fi%20horror%20series%20poster%2C%20neon%20red%20glowing%20upside%20down%20sky%20and%20bicycle%20silhouette%2C%20dark%20navy%20and%20electric%20red%20tones%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-14&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "428 KB",
    updatedAt: "2026-10-03",
    runtime: "全 4 季",
    region: "美国",
    rating: 8.8,
    downloads: 52900,
    featured: false,
    summary:
      "复古科幻剧《怪奇物语》全 4 季中文字幕，含 80 年代文化梗注释与专有名词对照，时间轴完整，适合科幻与怀旧爱好者。",
    tags: ["科幻", "恐怖", "文化注释", "全季打包"],
    versions: [
      {
        id: "stranger-things-2016-srt-sc",
        label: "简体中文 SRT（全 4 季）",
        format: "srt",
        language: "简体中文",
        size: "428 KB",
        lines: [
          "S01E01 00:06:18,400 --> 00:06:22,900  朋友们，不要说谎。",
          "S04E01 00:33:50,200 --> 00:33:54,700  颠倒世界一直在注视着我们。",
        ],
      },
    ],
  },
  {
    id: "singer-2024",
    title: "歌手2024",
    originalTitle: "Singer 2024",
    type: "综艺",
    typeSlug: "variety",
    year: 2024,
    cover:
      "https://readdy.ai/api/search-image?query=Music%20competition%20live%20show%20variety%20poster%2C%20glowing%20concert%20stage%20with%20spotlights%20and%20microphone%20silhouette%2C%20purple-pink%20and%20gold%20stage%20lights%20on%20dark%20background%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-15&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "142 KB",
    updatedAt: "2026-10-08",
    runtime: "全 13 期",
    region: "中国大陆",
    rating: 8.2,
    downloads: 43600,
    featured: false,
    summary:
      "《歌手2024》全 13 期中文字幕，收录歌手访谈与现场歌词字幕，时间轴按场次校对，适合综艺与音乐爱好者。",
    tags: ["音乐", "综艺", "歌词字幕", "全季打包"],
    versions: [
      {
        id: "singer-2024-srt-sc",
        label: "简体中文 SRT（全 13 期）",
        format: "srt",
        language: "简体中文",
        size: "142 KB",
        lines: [
          "【第 1 期】00:08:15,300 --> 00:08:19,800  【歌词】此刻我站在这里，唱给你听。",
          "【第 7 期】00:41:20,500 --> 00:41:25,900  恭喜本场排名第一的歌手！",
        ],
      },
    ],
  },
  {
    id: "back-to-field-2017",
    title: "向往的生活",
    originalTitle: "Back to Field",
    type: "综艺",
    typeSlug: "variety",
    year: 2017,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20countryside%20lifestyle%20variety%20show%20poster%2C%20a%20cozy%20rural%20cottage%20with%20a%20small%20vegetable%20garden%20and%20warm%20sunset%20light%2C%20green%20and%20amber%20tones%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-16&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "356 KB",
    updatedAt: "2026-10-02",
    runtime: "多季合集",
    region: "中国大陆",
    rating: 8.4,
    downloads: 29400,
    featured: false,
    summary:
      "慢综艺《向往的生活》多季中文字幕合集，收录嘉宾对白与环境旁白注释，时间轴按集校对，适合轻松生活类节目观看。",
    tags: ["生活", "综艺", "合集", "分集校对"],
    versions: [
      {
        id: "back-to-field-2017-srt-sc",
        label: "简体中文 SRT（多季合集）",
        format: "srt",
        language: "简体中文",
        size: "356 KB",
        lines: [
          "S01E01 00:04:30,200 --> 00:04:34,700  我们种下的每一颗种子，都会慢慢长大。",
          "S03E05 00:25:40,100 --> 00:25:44,600  慢下来，才能看见生活的样子。",
        ],
      },
    ],
  },
  {
    id: "keep-running-2014",
    title: "奔跑吧",
    originalTitle: "Keep Running",
    type: "综艺",
    typeSlug: "variety",
    year: 2014,
    cover:
      "https://readdy.ai/api/search-image?query=Energetic%20outdoor%20game%20variety%20show%20poster%2C%20dynamic%20colorful%20running%20figures%20with%20motion%20blur%2C%20bright%20amber%20and%20teal%20accents%20on%20a%20clean%20light%20background%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-17&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "288 KB",
    updatedAt: "2026-10-01",
    runtime: "多季合集",
    region: "中国大陆",
    rating: 8.0,
    downloads: 25100,
    featured: false,
    summary:
      "户外竞技综艺《奔跑吧》多季中文字幕合集，收录游戏规则说明与嘉宾对白字幕，时间轴完整，适合综艺爱好者收藏。",
    tags: ["竞技", "综艺", "合集", "分集校对"],
    versions: [
      {
        id: "keep-running-2014-srt-sc",
        label: "简体中文 SRT（多季合集）",
        format: "srt",
        language: "简体中文",
        size: "288 KB",
        lines: [
          "S01E01 00:03:12,400 --> 00:03:16,900  欢迎来到，奔跑吧！",
          "S05E03 00:18:20,700 --> 00:18:25,200  本局游戏的胜者是——",
        ],
      },
    ],
  },
  {
    id: "demon-slayer-2019",
    title: "鬼灭之刃",
    originalTitle: "Demon Slayer",
    type: "动漫",
    typeSlug: "anime",
    year: 2019,
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20anime%20action%20poster%2C%20a%20young%20swordsman%20holding%20a%20glowing%20water-pattern%20blade%20in%20a%20moonlit%20bamboo%20forest%2C%20deep%20teal%20and%20crimson%20tones%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-18&orientation=portrait",
    format: "ass",
    language: "中英双语",
    size: "1.8 MB",
    updatedAt: "2026-10-07",
    runtime: "多季合集",
    region: "日本",
    rating: 8.9,
    downloads: 92100,
    featured: false,
    summary:
      "热血动漫《鬼灭之刃》多季中英双语字幕，含呼吸法招式与专有名词注释，ASS 特效样式还原动画字幕观感，时间轴完整校对。",
    tags: ["热血", "战斗", "双语", "特效字幕"],
    versions: [
      {
        id: "demon-slayer-2019-ass-biling",
        label: "中英双语 ASS（特效）",
        format: "ass",
        language: "中英双语",
        size: "1.8 MB",
        lines: [
          "S01E01 00:14:20,300 --> 00:14:24,800  水之呼吸，第一型——水面斩！",
          "S02E05 00:19:12,400 --> 00:19:16,900  集中一点，登峰造极！",
        ],
      },
    ],
  },
  {
    id: "spy-x-family-2022",
    title: "间谍过家家",
    originalTitle: "SPY x FAMILY",
    type: "动漫",
    typeSlug: "anime",
    year: 2022,
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20anime%20comedy%20poster%2C%20a%20stylish%20family%20silhouette%20walking%20under%20a%20city%20skyline%20at%20dusk%2C%20warm%20amber%20and%20cool%20teal%20tones%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-19&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "364 KB",
    updatedAt: "2026-10-05",
    runtime: "多季合集",
    region: "日本",
    rating: 8.6,
    downloads: 58700,
    featured: false,
    summary:
      "治愈搞笑动漫《间谍过家家》多季中文字幕，收录角色俚语与谐音梗注释，时间轴按集校对，适合日常轻松追番。",
    tags: ["喜剧", "日常", "注释齐全", "分集校对"],
    versions: [
      {
        id: "spy-x-family-2022-srt-sc",
        label: "简体中文 SRT（多季合集）",
        format: "srt",
        language: "简体中文",
        size: "364 KB",
        lines: [
          "S01E01 00:05:30,400 --> 00:05:34,900  为了世界的和平，先组建一个家庭吧。",
          "S01E12 00:21:44,200 --> 00:21:48,700  我们的任务，才刚刚开始。",
        ],
      },
    ],
  },
  {
    id: "your-name-2016",
    title: "你的名字。",
    originalTitle: "Your Name.",
    type: "动漫",
    typeSlug: "anime",
    year: 2016,
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20anime%20film%20poster%2C%20two%20figures%20standing%20under%20a%20vast%20twilight%20sky%20with%20a%20passing%20comet%2C%20soft%20amber%20and%20indigo%20gradient%20tones%2C%20minimal%20poster%20art%2C%20no%20text&width=400&height=600&seq=sub-cover-20&orientation=portrait",
    format: "srt",
    language: "简体中文",
    size: "76 KB",
    updatedAt: "2026-10-04",
    runtime: "106 分钟",
    region: "日本",
    rating: 9.0,
    downloads: 77800,
    featured: false,
    summary:
      "新海诚经典动画电影《你的名字。》中文字幕，收录全部台词与日式称谓注释，时间轴匹配 106 分钟高清版，适合动画电影爱好者。",
    tags: ["爱情", "奇幻", "动画电影", "注释齐全"],
    versions: [
      {
        id: "your-name-2016-srt-sc",
        label: "简体中文 SRT",
        format: "srt",
        language: "简体中文",
        size: "76 KB",
        lines: [
          "00:20:12,400 --> 00:20:16,900  那一天，彗星划过天际，我遇见了你。",
          "01:12:40,300 --> 01:12:44,800  无论你在世界的哪个角落，我都会再次找到你。",
        ],
      },
    ],
  },
];

export interface CategoryInfo {
  slug: string;
  name: string;
  title: string;
  desc: string;
  icon: string;
  accent: string;
}

export const categories: CategoryInfo[] = [
  {
    slug: "movie",
    name: "电影字幕",
    title: "电影字幕",
    desc: "收录院线大片、经典影片与文艺佳作的高清中文字幕，时间轴精校，支持 SRT / ASS 多格式下载。",
    icon: "ri-film-line",
    accent: "primary",
  },
  {
    slug: "tv",
    name: "电视剧字幕",
    title: "电视剧字幕",
    desc: "覆盖国产剧、美剧、日韩剧等热门剧集的全季中文字幕打包，分集校对，追剧更省心。",
    icon: "ri-tv-2-line",
    accent: "accent",
  },
  {
    slug: "variety",
    name: "综艺字幕",
    title: "综艺字幕",
    desc: "音乐、竞技、生活类综艺节目的中文字幕合集，对白与歌词字幕齐全，轻松看懂每个笑点。",
    icon: "ri-mic-line",
    accent: "secondary",
  },
  {
    slug: "anime",
    name: "动漫字幕",
    title: "动漫字幕",
    desc: "日本动漫、动画电影的中文字幕资源，含专有名词与梗注释，双语文幕还原原声观感。",
    icon: "ri-magic-line",
    accent: "primary",
  },
];